import $ from "jquery";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
// import Exporting from "highcharts/modules/exporting";
// import ExportData from "highcharts/modules/export-data";
import Accessibility from "highcharts/modules/accessibility";

// Initialize the modules
HighchartsMore(Highcharts);
// Exporting(Highcharts);
// ExportData(Highcharts);
Accessibility(Highcharts);

// Make Highcharts available globally
window.Highcharts = Highcharts;

// JQuery globally
window.$ = $;

const applyChartColors = () => {
  const colors = ["#012C53", "#8A9EB0", "#E6EAEE"];
  const $charts = $(".HighchartsCard .chart");
  const currentWidth = $(window).width();

  $charts.each(function (_, chartContainer) {
    const chartId = $(chartContainer).children().first().attr("id");
    const renderChart = Highcharts.charts.find((chart) => {
      if (typeof chart === "undefined") {
        return false; // Skip this item if it is undefined
      }
      return chart.renderTo.id === chartId;
    });

    if (renderChart) {
      // Change chart height
      if ($(".ChartSlider").length > 0) {
        renderChart.update(
          {
            title: {
              style: {
                fontSize: "16px",
              },
            },
          },
          false
        );
        renderChart.redraw();

        if ($charts.hasClass("has-slickJs") && currentWidth == 769) {
          renderChart.setSize(200, 200, false);
        } else {
          renderChart.setSize(null, 200, false);
        }
      }

      if (renderChart.options.chart.type === "spline") {
        if (renderChart.series.length < 2) {
          renderChart.series[0].update({
            color: colors[0],
          });
        }

        // renderChart.series.forEach((series, index) => {
        //   series.update({
        //     color: colors[index % colors.length],
        //   });
        // });
      } else if (renderChart.options.chart.type === "line") {
        // renderChart.series.forEach((series) => {
        //   series.update({
        //     color: colors[0],
        //   });
        // });
      } else if (
        renderChart.options.chart.type === "area" ||
        renderChart.options.chart.type === "areaspline"
      ) {
        renderChart.series.forEach((series, index) => {
          series.update({
            lineColor: colors[index % colors.length],
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [
                  0,
                  Highcharts.color(colors[index % colors.length])
                    .setOpacity(0.6)
                    .get("rgba"),
                ],
                [
                  1,
                  Highcharts.color(colors[index % colors.length])
                    .setOpacity(0.1)
                    .get("rgba"),
                ],
              ],
            },
            marker: {
              states: {
                hover: {
                  fillColor: colors[0],
                },
              },
            },
          });
        });
      } else {
        renderChart.series[0].update({
          colors: ["#012C53", "#8A9EB0", "#E6EAEE"],
        });
      }
    }
  });
};

try {
  if ($(".chart").length > 0) {
    document.addEventListener("DOMContentLoaded", function () {
      applyChartColors();
    });
  }
} catch (e) {
  console.error("Post initChart: ", e);
}
